module.exports = __webpack_public_path__ + "img/cielo_payment_email.29a70e84.png";